import { all, put, takeEvery, call } from 'redux-saga/effects';
import { GetEmployeesActionTypes } from '../actionsTypes';
import { getEmployees } from '../mockController';
// import { getEmployees } from '../controller';


function* handleGetEmployeesRequest(action) {
    try {
        // const { params } = action.payload;
        yield put({ type: GetEmployeesActionTypes.INPROGRESS });
        const employees = yield call(getEmployees);
        yield put({ type: GetEmployeesActionTypes.SUCCESS, payload: employees });
    } catch (e) {
        // console.warn('FAILED to handle get Employees request due to', e.message);
        yield put({ type: GetEmployeesActionTypes.FAILED, error: e.message });
    }
}


function* watchGetEmployeesRequest() {
    yield takeEvery(GetEmployeesActionTypes.REQUEST, handleGetEmployeesRequest);
}

export function* testSaga() {
    yield all([
        watchGetEmployeesRequest()
    ]);
}
